module.exports = __webpack_public_path__ + "static/img/slide_1_1.19c4081.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcimages/slide_1_1.png
// module id = zPTI
// module chunks = 51